module.exports = __webpack_public_path__ + "img/footer-dark.c6be1da0.svg";